/** Settings section header in role permission trees. */
function isSettingsPermissionHeader(header: string | null | undefined): boolean {
  return header === 'Settings';
}

interface PermissionGroupLike {
  header?: string;
  moduleType?: string;
  permissions?: {
    module?: string;
    canView?: boolean;
    canAdd?: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
  }[];
}

/**
 * Finds the Settings group for a portal, preferring the module types in the order given.
 *
 * The scoping is load-bearing, not cosmetic. A role with Brooklyn access carries all three trees
 * in one stored array, and the Brooklyn tree is already headed "Settings" — so a header-only
 * lookup would return Brooklyn's group (which also has a "Users" leaf) instead of this portal's.
 */
export function findSettingsPermissionGroup<T extends PermissionGroupLike>(
  groups: T[] | null | undefined,
  moduleTypes: string[]
): T | undefined {
  for (const moduleType of moduleTypes) {
    const group = groups?.find(
      (candidate) =>
        candidate?.moduleType === moduleType && isSettingsPermissionHeader(candidate?.header)
    );
    if (group) {
      return group;
    }
  }
  return undefined;
}
